import { useQuery } from "@apollo/client";
import TranslationsListQuery from "../graphql/queries/TranslationsListQuery.graphql";
import TranslationsOptionsQuery from "../graphql/queries/TranslationsOptionsQuery.graphql";
import type {
  TranslationsListQueryType,
  TranslationsOptionsQueryType,
} from "@/types/graphql/admin.generated";
import type { TranslationsFilterInput } from "../model/types";

interface UseTranslationsQueryOptions {
  page?: number;
  rowsPerPage?: number;
  filter?: TranslationsFilterInput;
  skip?: boolean;
}

export function useTranslationsQuery({
  page = 0,
  rowsPerPage = 10,
  filter,
  skip = false,
}: UseTranslationsQueryOptions = {}) {
  return useQuery<TranslationsListQueryType>(TranslationsListQuery, {
    variables: { page, rowsPerPage, filter },
    skip,
  });
}

export function useTranslationsOptionsQuery(skip = false) {
  return useQuery<TranslationsOptionsQueryType>(TranslationsOptionsQuery, {
    skip,
  });
}
